import { useTranslation } from "react-i18next";

export default function InformationDiv({
  title,
  value,
  classList,
  pClasses,
  ...props
}) {
  const { t } = useTranslation("general");

  return (
    <div className={`view-user-entity ${classList}`} {...props}>
      <p className={pClasses ? pClasses : ""}>{t(title)}:</p>
      <span>{value ?? "-"}</span>
    </div>
  );
}
